import type { ValueOf } from '@common/utils/utilityTypes';

export const Werkdiagnose = {
    aspecifieke_lage_rugpijn: 'Aspecifieke lage rugpijn',
    lumbale_spinale_stenose: 'Lumbale spinale stenose',
    radiculair_syndroom: 'Radiculair syndroom',
} as const;
export type Werkdiagnose = ValueOf<typeof Werkdiagnose>;

export const werkdiagnoseOptions = [
    Werkdiagnose.aspecifieke_lage_rugpijn,
    Werkdiagnose.radiculair_syndroom,
    Werkdiagnose.lumbale_spinale_stenose,
];
